import React, { useMemo } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { format, parseISO } from 'date-fns';

const SYMPTOM_LINES = [
  { key: 'painLevel', name: 'Pain', color: '#ffffff' },
  { key: 'fatigueLevel', name: 'Energy', color: '#999999' },
];

export default function SymptomChart({ checkIns }) {
  const chartData = useMemo(() => {
    // Group by date, average values for each day
    const byDate = {};
    for (const c of checkIns) {
      if (!byDate[c.checkInDate]) {
        byDate[c.checkInDate] = { date: c.checkInDate, count: 0 };
        SYMPTOM_LINES.forEach(s => { byDate[c.checkInDate][s.key] = null; });
      }
      const entry = byDate[c.checkInDate];
      entry.count++;
      SYMPTOM_LINES.forEach(({ key }) => {
        if (c[key] != null) {
          entry[key] = entry[key] != null ? (entry[key] + c[key]) / 2 : c[key];
        }
      });
    }

    return Object.values(byDate).sort((a, b) => a.date.localeCompare(b.date));
  }, [checkIns]);

  if (chartData.length === 0) {
    return (
      <div className="glass rounded-xl p-6">
        <h3 className="text-sm font-semibold text-white mb-4">Symptom Trends</h3>
        <p className="text-white/50 text-center py-8">No data yet. Start checking in!</p>
      </div>
    );
  }

  return (
    <div className="glass rounded-xl p-6">
      <h3 className="text-sm font-semibold text-white mb-4">Symptom Trends (30 days)</h3>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
          <XAxis
            dataKey="date"
            tickFormatter={(d) => format(parseISO(d), 'MMM d')}
            fontSize={11}
            stroke="rgba(255,255,255,0.5)"
          />
          <YAxis domain={[0, 10]} fontSize={11} stroke="rgba(255,255,255,0.5)" />
          <Tooltip
            labelFormatter={(d) => format(parseISO(d), 'MMM d, yyyy')}
            formatter={(value) => value?.toFixed(1)}
          />
          <Legend />
          {SYMPTOM_LINES.map(({ key, name, color }) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              name={name}
              stroke={color}
              strokeWidth={2}
              dot={{ r: 3 }}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
